import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/users', process.env.VUE_APP_PUBLIC_SERVICE_BASE_URL).href
const httpClient = createHttpClient(baseUrl)

const END_POINT = 'account-managers'

const AccountManagerApi = {
  getAccountManagers() {
    const url = `${END_POINT}`
    return httpClient.get(url)
  },

  updateAccountManager(data) {
    const url = `${END_POINT}/change`
    return httpClient.patch(url, data)
  },
}

export default AccountManagerApi
